module.exports = __webpack_public_path__ + "static/media/3.f68e2630.png";